import moment from 'moment';
import { TaskConversionProcessIssueFile } from '../model/entities';
import { syncApiAxios } from './CustomAxios';
import { Page } from '../model/elements';

class TaskConversionProcessIssueFileApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskConversionProcessIssueId: number,
        searchText?: string,
    ): Promise<Page<TaskConversionProcessIssueFile>> => {
        const response = await syncApiAxios.get<Page<TaskConversionProcessIssueFile>>(
            '/task-conversion-process-issue-files',
            {
                params: { page, size, sortField, sortOrder, taskConversionProcessIssueId, searchText },
            },
        );
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };
}

const taskConversionProcessIssueFileApi: TaskConversionProcessIssueFileApi = new TaskConversionProcessIssueFileApi();
export default taskConversionProcessIssueFileApi;
